import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heders from "../components/Headers";
import BannerAdsOne from "../components/BannerAdsOne";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import { get_category, get_products } from "../store/reducers/homeReducer";
import AllBlogs from "../components/blogs/AllBlogs";
import AllDoctors from "../components/doctors/AllDoctors";

const Doctors = () => {
  const dispatch = useDispatch();
  const { latest_product, topRated_product, discount_product } = useSelector(
    (state) => state.home
  );
  useEffect(() => {
    dispatch(get_products());
  }, []);
  return (
    <div className="w-full">
      <section
        className="h-[280px] bg-cover bg-no-repeat relative bg-center"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/heroBg.jpg)`,
        }}
      >
        <Heders />
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto mt-20 ">
            <div className="div-gradient-t1">
              <h1 className="sm:text-[35px] text-[55px] gradient-t0">
                Doctors
              </h1>
              <div className="w-[200px] sm:w-[150px] h-[8px] bg-[#fefefe] rounded-full"></div>
            </div>
          </div>
        </div>
      </section>

      <div className="py-[45px]">
        <AllDoctors />
      </div>
      <BannerAdsOne />
      <div className="py-10">
        <div className="w-[85%] flex flex-wrap mx-auto">
          <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
            <div className="overflow-hidden">
              <Products title="أحدث" products={latest_product} />
            </div>
            <div className="overflow-hidden">
              <Products title="أفضل تقييم" products={topRated_product} />
            </div>
            <div className="overflow-hidden">
              <Products title="سعر مخفض" products={discount_product} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Doctors;
